import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import ResizeMixin from '../../mixin/resize';
import { mixins } from 'vue-class-component';
import { shouldHideHeaderAndFooter } from '@/router/components/layout/utils';
let default_1 = class extends mixins(ResizeMixin) {
    get sidebarOpen() {
        const widthContainer = this.sidebar.opened ? 'width: calc(100% - 27.0rem);' : 'width:calc(100% - 4.0rem);';
        const showFooter = shouldHideHeaderAndFooter(this.$route.path) ? ' display: none;' : ' display: flex;';
        return widthContainer + showFooter;
    }
};
default_1 = __decorate([
    Component({
        name: 'Footer',
    })
], default_1);
export default default_1;
